/**
 * Miorenée blog article enhancements.
 *
 * Tags every external link inside the article body with
 * target="_blank" and rel="noopener noreferrer" so source
 * citations open in a new tab without leaking referrers.
 *
 * Scoped to .content-blog (the RTE container used by the
 * article template) so navigation and other links are
 * untouched.
 */
(function () {
  function tagExternalLinks() {
    var links = document.querySelectorAll('.content-blog a[href^="http"]');
    var host = window.location.hostname;

    links.forEach(function (a) {
      try {
        var url = new URL(a.href);
        if (url.hostname && url.hostname !== host) {
          a.setAttribute('target', '_blank');
          a.setAttribute('rel', 'noopener noreferrer');
        }
      } catch (e) {
        // Malformed href — leave it alone.
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagExternalLinks);
  } else {
    tagExternalLinks();
  }
})();
